export const ActionTypes = {
  FETCH_ALL: 'services/avg_cycletime/fetch_all',
  SET_LOADER_STATUS: 'services/avg_cycletime/set_loader_status',
  SET_ALL: 'services/avg_cycletime/set_all',
  UPDATE_TOOL_CYCLE_TIME: 'services/avg_cycletime/update_tool_cycle_time',
  TOOL_CYCLE_TIME_EXPORT: 'services/avg_cycletime/export_tool_cycle_time',
  SET_TOOL_CYCLE_TIME_EXPORT_LOADER: 'services/avg_cycletime/export_tool_cycle_time_loader',
  SET_TOOL_CYCLE_TIME_EXPORT: 'services/avg_cycletime/set_export_tool_cycle_time',
};

const fetchAll = ({ toolCycleTimeParams }) => ({
  toolCycleTimeParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ toolCycleTimeData }) => ({
  toolCycleTimeData,
  type: ActionTypes.SET_ALL,
});

const updateToolCycleTime = ({ toolData, toolCycleTimeParams }) => ({
  toolData,
  toolCycleTimeParams,
  type: ActionTypes.UPDATE_TOOL_CYCLE_TIME,
});

//--------------------------------------- tool cycle time export file actions
const toolCycleTimeExport = () => ({
  type: ActionTypes.TOOL_CYCLE_TIME_EXPORT,
});
const setToolCycleTimeExportLoader = ({ toolCycleTimeExportByLoader }) => ({
  toolCycleTimeExportByLoader,
  type: ActionTypes.SET_TOOL_CYCLE_TIME_EXPORT_LOADER,
});
const setToolCycleTimeExportData = ({ toolCycleTimeExportData }) => ({
  toolCycleTimeExportData,
  type: ActionTypes.SET_TOOL_CYCLE_TIME_EXPORT,
});
export default {
  fetchAll,
  setAll,
  setLoader,
  updateToolCycleTime,
  toolCycleTimeExport,
  setToolCycleTimeExportLoader,
  setToolCycleTimeExportData,
};
